import React from "react";
import type { PositionReading } from "../../tarot/reading/types";
import { ReadingSections } from "./ReadingSections";

export interface CardReadingProps {
  reading: PositionReading;
}

export const CardReading: React.FC<
  CardReadingProps
> = ({
  reading,
}) => (
  <div className="slot-card">
    <header className="slot-card__header">
      <div className="slot-card__kicker">
        Выпавшая карта
      </div>

      <div className="slot-card__name">
        {reading.cardName}
      </div>

      {reading.cardNameEn ? (
        <div className="slot-card__name-en">
          {reading.cardNameEn}
        </div>
      ) : null}
    </header>

    <ReadingSections
      sections={reading.sections}
    />
  </div>
);

